import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function createWithdrawalAccount(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = urls.createWithdrawalAccount
  const storeId = await self.servicesVars.getStoreId()

  const body = {
    email: '',
    ownerId: storeId,
    metadata: {
      type: data.accountType,
      accountId: data.accountId,
      bankName: data.bankName || '',
      bankCode: data.bankCode || '',
      boxCode: data.boxCode || '',
      operator: data.operator || '',
    },
    lastName: '',
    fullName: data.name,
    firstName: '',
    phoneNumber: '',
    countryCode: data.countryCode,
    businessName: '',
  }
  const response = await Network.sendPostRequest(url, body)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    return {
      success: true,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { createWithdrawalAccount }
